import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../slices/thunks";
//redux
import { useDispatch } from "react-redux";
import withRouter from "../../Components/Common/withRouter";

/**
 * Logout component for handling user logout.
 *
 * This component dispatches a Redux action to log the user out and navigates
 * to the "/logout" route. It is typically used to perform logout-related actions
 * upon mounting.
 *
 * @component
 */
const Logout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(logoutUser());
		navigate("/logout", {state: true});
	}, [dispatch]);

	return <></>;
};

Logout.propTypes = {
	history: PropTypes.object,
};


export default withRouter(Logout);